// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "news-4a753f38/chunk-" + {"190": "144b49102acdf44f","288": "8f84af20ad917330","52": "148682781775c445",}[chunkId] + ".js"
}